module.exports = __webpack_public_path__ + "media/images/area/feature/banner/sp/ja_okinawa-1a2194d560d130f98282ffa29703051c.jpg";